import React, { useEffect, useState } from "react";
import { ICourseNews } from "common/types";
import api from "common/api";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";

interface CourseNewsEditModalProps {
  show: boolean;
  onHide: () => void;
  newsItem: ICourseNews;
  onNewsUpdate: (newsItem: ICourseNews) => void;
}

const CourseNewsEditModal: React.FC<CourseNewsEditModalProps> = ({
  show,
  onHide,
  newsItem,
  onNewsUpdate,
}) => {
  const [title, setTitle] = useState(newsItem.title);
  const [content, setContent] = useState(newsItem.content);

  useEffect(() => {
    setTitle(newsItem.title);
    setContent(newsItem.content);
  }, [newsItem]);

  const handleTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(event.target.value);
  };

  const handleContentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setContent(event.target.value);
  };

  const handleUpdate = async () => {
    try {
      const response = await api.put(`/news/${newsItem.id}/`, {
        course: newsItem.course,
        title,
        content,
      });
      onNewsUpdate(response.data);
      toast.success("Novost uspješno promijenjena");
    } catch (error) {
      console.log(error);
      toast.error("Greška prilikom promjene novosti");
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Promijeni novost</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <label htmlFor="name" className="form-label">
            Naslov
          </label>
          <input
            type="text"
            className="form-control"
            id="title"
            value={title}
            onChange={handleTitleChange}
            autoFocus
          />
        </div>
        <div className="mb-3">
          <Form.Group>
            <Form.Label>Sadržaj</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              id="content"
              value={content}
              onChange={handleContentChange}
            />
          </Form.Group>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" onClick={onHide}>
          Odustani
        </Button>
        <Button variant="primary" onClick={handleUpdate}>
          Promijeni
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CourseNewsEditModal;
